import { render, staticRenderFns } from "./detect.vue?vue&type=template&id=01d09f1d&"
import script from "./detect.vue?vue&type=script&lang=js&"
export * from "./detect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports